<template>
    <div :class="styleMain">
      <el-switch v-model="chance" />
      <div class="title">Occasion</div>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionChance',
  props: {
    action: Object
  },
  computed: {
    chance: {
      get () { return this.action.chance },
      set (value) {
        this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, chance: value })
      }
    },

    styleMain () { return ['sportFootballMatchActionChance', this.action.homeAway] }
  }
}
</script>

<style>
.sportFootballMatchActionChance {
  grid-area: owngoal;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.sportFootballMatchActionChance > div{
  flex:1
}
.sportFootballMatchActionChance > div.title{
  font-size:8px;
  margin-top:5px;
  z-index:1
}
.sportFootballMatchActionChance.home .el-switch.is-checked .el-switch__core{
  border-color:var(--color-team-home);
  background-color:var(--color-team-home)
}
.sportFootballMatchActionChance.away .el-switch.is-checked .el-switch__core{
  border-color:var(--color-team-away);
  background-color:var(--color-team-away)
}
</style>
